<db-dialog-wrapper [dialog]="this" [width]="'488px'" [height]="'195px'" [canClose]="!loading" [hasCloseButton]="!loading" [canCloseByBackdrop]="!loading">
  <div class="db-remove-dns-dialog db-remove-dns-dialog-sm">
    <div class="db-remove-dns-dialog__header">{{'text_confirmRecordRemove.header' | dbText}}</div>
    <div class="db-remove-dns-dialog__message">
      <span [innerHTML]="'text_confirmRecordRemove.message' | dbText"></span>
    </div>
    <div class="db-remove-dns-dialog__buttons">
      <a class="db-button" (click)="cancel()" [ngClass]="{'db-button_disabled': loading}"><span>{{"text_cancel" | dbText}}</span></a>
      <a class="db-button db-button_danger" (click)="confirm()">
        <span *ngIf="!loading">{{'text_removeDemoWebsiteBtn' | dbText}}</span>
        <db-loading-circular-spinner *ngIf="loading"></db-loading-circular-spinner>
      </a>
    </div>
  </div>
</db-dialog-wrapper>
